// src/components/SERVICE.js
import React from 'react';
import './service.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCode,
  faRocket,
  faPaintBrush,
  faVideo,
  faRobot,
  faUserTie,
  faClipboardList,
  faPhoneAlt,
} from '@fortawesome/free-solid-svg-icons';

const SERVICE = () => {
  const services = [
    {
      id: 1,
      title: 'Création Web & Solutions Digitales',
      description: 'Développement de sites web sur mesure, applications et outils digitaux pour votre activité.',
      icon: faCode,
      features: ['Sites Web Responsive',
      'Applications Web',
      'Outils Digitaux Personnalisés',
      'E-commerce & Marketplaces'],
    },
    {
      id: 2,
      title: 'Marketing Digital & Réseaux Sociaux',
      description: 'Stratégie et gestion complète de votre présence digitale et campagnes sur les réseaux sociaux.',
      icon: faRocket,
      features: ['Gestion Réseaux Sociaux',
      'Services TikTok Professionnels',
      'Stratégie de Contenu',
      'Campagnes Publicitaires'],
    },
    {
      id: 3,
      title: 'Identité Visuelle & Création Graphique',
      description: 'Conception de votre identité de marque et création d\'éléments graphiques professionnels.',
      icon: faPaintBrush,
      features: [ 'Logo & Charte Graphique',
      'Design Print & Digital',
      'Branding Complet',
      'Supports de Communication'],
    },
    {
      id: 4,
      title: 'Contenu Vidéo & Animations Logo',
      description:  'Production de contenu vidéo professionnel et animations pour valoriser votre marque.',
      icon: faVideo,
      features: ['Vidéos Institutionnelles',
      'Animations 2D/3D',
      'Motion Design',
      'Montage & Post-production',
       ],
    },
    {
      id: 5,
      title: 'Automatisation & Communication Pro',
      description: 'Solutions d\'email professionnel et systèmes d\'automatisation pour optimiser vos processus.',
      icon: faRobot,
      features: ['Emails Professionnels',
      'Automatisation Marketing',
      'CRM & Gestion Clients',
      'Workflows Automatisés'],
    },
    {
      id: 6,
      title: 'Accompagnement & Formations Stratégiques',
      description: 'Formations pratiques et accompagnement personnalisé pour maîtriser les outils digitaux.',
      icon: faUserTie,
      features: ['Formations Pratiques',
      'Stratégie Digitale',
      'Accompagnement Personnalisé',
      'Audit & Conseils'],
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        {/* En-tête avec badge et titre */}
        <div className="services-header">
          <div className="section-badge">
            <span className="badge-text">NOS EXPERTISES</span>
          </div>
          
          <h2 className="section-title">
            <span className="title-line">Solutions Digitales</span>
            <span className="title-line highlight">Innovantes</span>
          </h2>
        </div>

        {/* Grille des services */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="service-card-inner">
                {/* En-tête de la carte */}
                <div className="service-card-header">
                  <div className="service-icon-container">
                    {/* Icône FontAwesome */}
                    <FontAwesomeIcon 
                      icon={service.icon} 
                      className="service-icon" 
                    />
                    
                    {/* Effet de fond */}
                    <div className="icon-background"></div>
                  </div>
                  
                  <div className="service-number">
                    <span className="number-text">0{service.id}</span>
                  </div>
                </div>

                {/* Corps de la carte */}
                <div className="service-card-body">
                  <h3 className="service-title">{service.title}</h3>
                  
                  <p className="service-description">{service.description}</p>
                  
                  <div className="service-features">
                    <h4 className="features-title">Nos prestations</h4>
                    <ul className="features-list">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="feature-item">
                          <span className="feature-icon">✓</span>
                          <span className="feature-text">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                
              </div>
              
              {/* Effet de bordure animée */}
              <div className="service-border"></div>
            </div>
          ))}
        </div>

        {/* Section CTA globale */}
        <div className="services-cta-section">
          <div className="cta-content">
            <h3 className="cta-title">Un projet spécifique ?</h3>
            <p className="cta-description">
              Nos experts sont à votre disposition pour étudier votre besoin 
              et vous proposer une solution sur mesure.
            </p>
            
            <div className="cta-actions">
              <button className="btn btn-primary">
                <FontAwesomeIcon icon={faClipboardList} className="btn-icon" />
                
                <a href="https://wa.me/message/5LI3MKHNRDERH1" target='blank' className='text-decoration-none text-white'>Demander un audit gratuit</a>
              </button>
              
            <a 
              href="tel:+2290162604943 " 
              className="btn btn-outline"
            >
              <FontAwesomeIcon icon={faPhoneAlt} className="btn-icon" />
              Prendre rendez-vous
            </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SERVICE;